import { render, staticRenderFns } from "./500-cover.vue?vue&type=template&id=4cb7f9fe"
import script from "./500-cover.vue?vue&type=script&lang=js"
export * from "./500-cover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports